<template>
  <div class="widget">
    <div class="widget-title">
      <div class="board-head">{{ title('Summary Monthly') }}</div>
    </div>
    <div class="widget-content">
      <div class="widget-item" v-if="settings.value.show_goal">
        <p class="monthly">
          Monthly Goal :
          <span class="value goal">
            {{ getData.goal | numFormat(currency) }}
          </span>
          <span class="word-sales" v-if="!currency">Sales</span>
        </p>
      </div>
      <div class="widget-item" v-if="settings.value.show_current_total_value">
        <p class="current">
          Current Total :
          <span class="value total">
            {{ getData.total | numFormat(currency) }}
          </span>
          <span class="word-sales" v-if="!currency">Sales</span>
        </p>
      </div>
      <div class="widget-item" v-if="settings.value.show_needed_per_day">
        <p class="per-day">
          Needed Per Day :
          <span class="value needed">
            {{ getData.need_per_day | numFormat(currency) }}
          </span>
          <span class="word-sales" v-if="!currency">Sales</span>
        </p>
      </div>
      <div class="widget-item" v-if="settings.value.show_needed_per_week">
        <p class="per-day">
          Needed Per Week :
          <span class="value needed">
            {{ getData.need_per_week | numFormat(currency) }}
          </span>
          <span class="word-sales" v-if="!currency">Sales</span>
        </p>
      </div>
      <div class="widget-item" v-if="settings.value.show_working_days">
        <p class="working-days">
          <span class="values working-days">
            Days :
            Working -
            <span class="value days">{{ getData.working | dayFormat }}</span>
            | Left -
            <span class="value days">{{ getData.remaining }}</span>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import widgetHelper from "@/mixins/widgetHelper";

export default {
  mixins: [widgetHelper],
  computed: {
    getData() {
      let goal = 0;
      let total = 0;

      let working = 0;
      let remaining = 0;

      let need_per_day = 0;
      let need_per_week = 0;

      let weekly_days_working = 0;

      const elems = this.getElemsForCalc;

      if (elems?.length) {
        for (const elem of elems) {
          goal += elem[this.useByPaymentCapacity('monthly')]?.goal || 0;

          if (this.target_type === 'Amount') {
            total += elem[this.useByPaymentCapacity('monthly')]?.[this.useNetAmount()] || 0;
          } else {
            total += (elem[this.useByPaymentCapacity('monthly')]?.[this.useNetCount] || 0);
          }

          //
          if (elem[this.useByPaymentCapacity('monthly')]?.days?.working > working) {
            working = elem[this.useByPaymentCapacity('monthly')]?.days?.working || 0;
            remaining = elem[this.useByPaymentCapacity('monthly')]?.days?.remaining || 0;

            // weekly_days_remaining = elem.weekly?.days?.remaining;
            weekly_days_working = elem[this.useByPaymentCapacity('weekly')]?.days?.working;
          }
        }

        need_per_day = (goal - total) / remaining;
        if (need_per_day < 0) { need_per_day = goal / working; }

        need_per_week = need_per_day * weekly_days_working;
      }
      return { goal, total, working, remaining, need_per_day, need_per_week };
    },
    ...mapGetters(["streams"]),
  },
};
</script>
